import { useContext } from 'react'
import LocalizedStrings from 'react-localization'
import localization from '../localization'
import { SharedContext } from '@/context/SharedContext'

export default function useTranslation() {
  const { language } = useContext(SharedContext)

  let translation = new LocalizedStrings(localization)
  if (language) translation?.setLanguage(language)
  return translation
}
